var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _rect2, _path14, _rect3, _rect4, _g, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncLoadingImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 78,
    viewBox: "0 0 101 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.717 48.0061L72.3551 75.0537L0.370888 73.3933C0.351623 73.3915 0.333319 73.384 0.318336 73.3717C0.303352 73.3595 0.292329 73.343 0.286694 73.3245C0.281059 73.306 0.281074 73.2862 0.286694 73.2677C0.292314 73.2492 0.30327 73.2328 0.318244 73.2205L29.6198 47.9911H100.327",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.717 48.0061L72.3551 75.0537L0.370888 73.3933C0.351623 73.3915 0.333319 73.384 0.318336 73.3717C0.303352 73.3595 0.292329 73.343 0.286694 73.3245C0.281059 73.306 0.281074 73.2862 0.286694 73.2677C0.292314 73.2492 0.30327 73.2328 0.318244 73.2205L29.6198 47.9911H100.327",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4309 74.8506L100.718 48.0058V50.8683L72.5512 77.5553",
    fill: "#B4B4B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4309 74.8506L100.718 48.0058V50.8683L72.5512 77.5553",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.72 0.281493H29.4793V48.0055H100.72V0.281493Z",
    fill: "#B4B4B4",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8529 67.4351L15.9598 66.7739L34.4423 52.341H85.8929L68.8529 67.4351Z",
    fill: "#8C8C8C",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4065 66.8866L42.3106 52.341",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1542 67.2998L76.6668 52.341",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0942 67.1496L64.7045 52.341",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1327 67.0218L53.0142 52.341",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8084 56.736L79.8307 57.7052",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2213 61.8823L74.2803 62.6261",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2253 4.2783H33.2652V44.3388H97.2253V4.2783Z",
    fill: "#B4CE67",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.4305,
    y: 15.2404,
    width: 16.8344,
    height: 16.8344,
    rx: 8.37958,
    fill: "#F9C54D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.4305,
    y: 15.2404,
    width: 16.8344,
    height: 16.8344,
    rx: 8.37958,
    stroke: "#131414",
    strokeWidth: 0.540618
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9871 23.6566C83.9997 23.2307 83.9255 22.8048 83.7701 22.4089C83.6146 22.0116 83.3808 21.6514 83.0825 21.3484C82.7842 21.0455 82.4286 20.8082 82.0379 20.6496C81.6472 20.4909 81.2271 20.4137 80.8042 20.4252C78.9236 20.4252 77.5891 21.7744 77.5891 23.6566C77.5891 25.5389 78.9264 26.9095 80.8042 26.9095C82.682 26.9095 83.9843 25.4889 83.9843 23.6566H83.9871ZM84.2224 19.2604H85.491V28.0715H84.0011V26.002C83.4606 27.354 82.1751 28.243 80.4471 28.243C77.8075 28.243 76.0796 26.2264 76.0796 23.6409C76.0796 21.0555 77.8397 19.0731 80.5311 19.0731C81.2453 19.0646 81.9482 19.2561 82.5602 19.6277C83.1735 19.9993 83.6706 20.5352 83.9997 21.1769V21.267L84.221 19.2618L84.2224 19.2604Z",
    fill: "#131414"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3973,
    y: 14.698,
    width: 16.8344,
    height: 16.8344,
    rx: 8.37958,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3973,
    y: 14.698,
    width: 16.8344,
    height: 16.8344,
    rx: 8.37958,
    stroke: "#131414",
    strokeWidth: 0.540618
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_8711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4568 18.297C44.1629 18.297 43.9246 18.5353 43.9246 18.8291V22.5098C43.9246 22.7962 44.1568 23.029 44.4432 23.029H46.2981C47.1472 23.029 48.3132 22.8546 48.6329 21.3465C48.6329 21.3465 48.9512 19.8364 49.1392 18.9418C49.2091 18.6092 48.9553 18.297 48.6152 18.297H44.4568Z",
    fill: "#788FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5554 20.0429C50.3032 20.0429 49.5627 20.5702 49.2254 21.7023C49.2254 21.7003 48.3532 24.3982 48.3532 24.3982C48.0336 25.2846 47.5184 25.649 46.5784 25.649H44.4228C44.1473 25.6497 43.9246 25.873 43.9246 26.1479V27.523C43.9246 27.7856 44.1378 27.9987 44.4011 27.9987H53.1524C53.4266 27.9987 53.6492 27.7761 53.6492 27.5019V20.522C53.6492 20.2573 53.4348 20.0429 53.1701 20.0429H51.5554Z",
    fill: "#788FB2"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5474 30.8684C61.1613 31.3925 57.1983 28.5787 56.6833 24.5696C56.1684 20.5605 59.3132 16.9008 63.6993 16.3766C68.0854 15.8525 72.0486 18.6663 72.5543 22.6662C73.0601 26.6661 69.9244 30.3442 65.5474 30.8684Z",
    fill: "#F9C54F",
    stroke: "#010101",
    strokeWidth: 0.915541,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9119 22.9883C59.9588 24.1239 60.4339 25.1995 61.2418 25.9989C62.0496 26.7982 63.1302 27.2621 64.2661 27.297C65.4021 27.332 66.5091 26.9355 67.3646 26.1873C68.2201 25.4391 68.7606 24.3947 68.8772 23.2642C68.9508 22.6481 67.9577 22.6573 67.9577 23.2642C67.8304 24.1283 67.3881 24.9148 66.716 25.4725C66.0439 26.0302 65.1893 26.3198 64.3165 26.2856C63.4438 26.2514 62.6146 25.8957 61.9882 25.2871C61.3618 24.6784 60.9826 23.8597 60.9233 22.9883C60.9233 22.3723 59.9302 22.3723 60.0038 22.9883H59.9119Z",
    fill: "#010101"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.948 22.4086C63.1968 22.4086 63.3985 22.211 63.3985 21.9672C63.3985 21.7235 63.1968 21.5259 62.948 21.5259C62.6991 21.5259 62.4973 21.7235 62.4973 21.9672C62.4973 22.211 62.6991 22.4086 62.948 22.4086Z",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.228885,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.11 22.4733C66.3588 22.4733 66.5605 22.2757 66.5605 22.0319C66.5605 21.7882 66.3588 21.5906 66.11 21.5906C65.8611 21.5906 65.6594 21.7882 65.6594 22.0319C65.6594 22.2757 65.8611 22.4733 66.11 22.4733Z",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.228885,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4774 77.5555L0.29032 76.128V73.4382L34.0548 74.137L72.4774 74.8507V77.5555Z",
    fill: "#B4B4B4",
    stroke: "#010101",
    strokeWidth: 0.561051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_8711"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.3832,
    y: 17.686,
    width: 10.8594,
    height: 10.8594,
    rx: 0.946082,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncLoadingImage);
export default __webpack_public_path__ + "static/media/sync_loading_image.f4e9c559f923c1606bbd2d61ab7765ff.svg";
export { ForwardRef as ReactComponent };